// The cohort a person consented to be counted in — coarse bands only.
//
// Everything here is already generalized by the time it is called: see onboarding/generalize.ts.
// No exact birth date, no city, no free text. If a value would not be safe to print on a chart
// with four other people, it does not belong in this shape.

import { apiGet, apiPut } from './client';

export interface Cohort {
  /** False when this person has never been through onboarding, which is what triggers the flow. */
  completed: boolean;
  age_band: string | null;
  region: string | null;
  gender: string | null;
  life_chapter: string | null;
  zodiac_sun: string | null;
  zodiac_moon: string | null;
  dream_recall: string | null;
  intentions: string[];
  /** Consent to be part of the collective picture. Personalization works either way. */
  collective_ok: boolean;
  consent_version: string | null;
}

export function getCohort(signal?: AbortSignal): Promise<Cohort> {
  return apiGet<Cohort>('/api/cohort', signal);
}

/**
 * Save a subset. The server merges over what it holds, so onboarding can persist screen by screen
 * and someone who closes the tab halfway keeps the answers they already gave.
 */
export function saveCohort(patch: Partial<Omit<Cohort, 'completed' | 'consent_version'>>): Promise<Cohort> {
  return apiPut<Cohort>('/api/cohort', patch as Record<string, unknown>);
}
